import { useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
// import Image from 'react-bootstrap/Image';
import NotificationsAlert from "../../services/NotificationsAlert";
import { ClienteContext } from "../../services/ClienteContext";
import Conect from "../../../Api/Conect";

import "./RecPass.css";
import Logo from '../../assets/Logo.png'


const RecPass = () => {

    const history = useNavigate();
    const { register, handleSubmit, } = useForm();
    const cliente = useContext(ClienteContext);
    const [email, setEmail] = useState()

    const onSubmit = async (data) => {

        const usuario = await Conect.post("/login", {
            email: data.email,
        })
        if (usuario.data.erro === true) {
            if (usuario.data.status === true) {
                NotificationsAlert("danger", "Atenção", usuario.data.msg)
            } else {
                NotificationsAlert("warning", "Atenção", usuario.data.msg)
            }
        }
        else {
            localStorage.setItem("id", usuario.data.data.id)
            localStorage.setItem("accessDescription", usuario.data.data.accessDescription)
            localStorage.setItem("accessLevel", usuario.data.data.accessLevel)
            localStorage.setItem("cpf", usuario.data.data.cpf)
            localStorage.setItem("createdAt", usuario.data.data.createdAt)
            localStorage.setItem("email", usuario.data.data.email)
            localStorage.setItem("firstName", usuario.data.data.firstName)
            localStorage.setItem("lastName", usuario.data.data.lastName)
            localStorage.setItem("image", usuario.data.data.image)
            localStorage.setItem("id_cli", usuario.data.data.id_cli)
            localStorage.setItem("stateDescription", usuario.data.data.stateDescription)
            localStorage.setItem("stateFuso", usuario.data.data.stateFuso)
            localStorage.setItem("statePrefix", usuario.data.data.statePrefix)
            localStorage.setItem("token", usuario.data.data.token)

            cliente.setDados({
                user_id: usuario.data.data.id,
                name: usuario.data.data.firstName,
                token: usuario.data.data.token,
                position: usuario.data.data.accessDescription,
                image: usuario.data.data.image,
                id_cli:usuario.data.data.id_cli
            });
            let message = `Olá! ${usuario.data.data.firstName}!`
            NotificationsAlert("default", message, "")
            history("/home");
        }
    };

    return (
        <div style={{ width: '100vw', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="container-login">
                <div className="wrap-login">
                    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                        <span className="login-form-title"> Recuperar acesso. </span>

                        <span className="login-form-title">
                            <img src={Logo} alt="Sakamotto Server Logo" />
                        </span>
                        <p className="p-rec-pass">Para que seja possivel recuperar seu acesso, informe seu email.</p>

                        <div className="wrap-input">
                            <input
                                className={email !== "" ? "has-val input" : "input"}
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                {...register("email")}
                            />
                            <span className="focus-input" data-placeholder="Email"></span>
                        </div>

                        <div className="container-login-form-btn">
                            <button className="login-form-btn">Enviar</button>
                        </div>

                        <div className="text-center">
                            <span className="txt1">Logar com seu email? </span>
                            <a className="txt2" href="/login">
                                Entrar!
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

}

export default RecPass;
